export default class Base64ToBlobService {
    convertData(imageData) {
        let byteString;
        if (imageData.split(",")[0].indexOf("base64") >= 0) byteString = atob(imageData.split(",")[1]);
        else byteString = decodeURI(imageData.split(",")[1]);
        // separate out the mime component
        const mimeString = imageData.split(",")[0].split(":")[1].split(";")[0];
        // write the bytes of the string to a typed array
        let ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], { type: mimeString });
    }
}
